import fetch from '../utils/fetch'

// 弹窗配置列表
export function getPopupConfigList(query) {
  return fetch({
    url: '/promotions/open_screen/list',
    method: 'get',
    params: query
  })
}

// 弹窗配置
export function getPopupConfig(id) {
  return fetch({
    url: '/promotions/open_screen/get',
    method: 'get',
    params: { id }
  })
}

// 终止配置
export function endPopup(id) {
  return fetch({
    url: '/promotions/open_screen/stop?id=' + id,
    method: 'post'
  })
}

// 创建配置
export function createPopupConfig(query) {
  return fetch({
    url: '/promotions/open_screen/save',
    method: 'post',
    params: query
  })
}

// 修改配置
export function editPopupConfig(id, query) {
  return fetch({
    url: '/promotions/open_screen/save',
    method: 'post',
    params: {
      ...query,
      id
    }
  })
}
